import React, {useEffect} from 'react'
import Header from '../../components/header/Header'
import './Transactions.css'
import ListTransaction from './ListTransaction'
import useIsMobile from '../main/useIsMobile'
import axios from "axios";
import {useTranslation} from "react-i18next";


const Transactions = () => {
    const {t} = useTranslation()
    const token = localStorage.getItem('token');
    const isMobile = useIsMobile()

    const [transactions, setTransactions] = React.useState([])
    const [transactionsLoaded, setTransactionsLoaded] = React.useState(false)

    const requireTransactions = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/transaction`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                setTransactions(res.data)
                setTransactionsLoaded(true)

            })}

    useEffect(() => {
        requireTransactions()
    }, []);
  return (
    <div className='Transactions'>
        <Header hasMenu2={true} isFixed={isMobile}/>
        <div className="TransactionsWrapper">
            <div className="TransactionsBlock">
                <h2>{t('transactions.transactionHistory')}</h2>
                <div className="historyTransaction">
                    {!isMobile && (
                        <ul className='nameColumns'>
                            <li>{t('transactions.type')}</li>
                            <li>{t('transactions.paymentMethod')}</li>
                            <li>{t('transactions.paymentID')}</li>
                            <li>{t('transactions.amount')}</li>
                            <li>{t('transactions.date')}</li>
                            <li>{t('transactions.status')}</li>
                        </ul>
                    )}
                    <ListTransaction isLoadedList={transactionsLoaded} listTransaction={transactions} isMobile={isMobile}/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Transactions
